<template>
  <header class="ant-layout-header pCKI81C6T6W2e4ZAfsHW uJNjizvqNTc61kuO2wZO">
    <div class="IZ3RIKA0JMiWHOYb9u5f">
      <div class="DMmVnO4MrRvIrs3lfxmS" @click="goBack">
        <svg-icon
          className="imageWrap"
          icon-class="comm_icon_fh--svgSprite:all"
        />
      </div>
      <div class="urdJVIoQ0Du2bRHlCOjg danger-cmesn">
        <van-tabs
          v-model="activeName"
          @click="routerFun"
          background="var(--theme-main-bg-color)"
          :lineWidth="activeLength * 7 + 'px'"
          title-active-color="var(--theme-primary-color)"
          title-inactive-color="var(--theme-text-color-darken)"
          color="var(--theme-primary-color)"
        >
          <van-tab
            title-style="font-size: 0.24rem;"
            v-if="
              !$store.state.config.event_hide ||
              !$store.state.config.event_hide.includes(item.route)
            "
            v-for="(item, index) in tabList"
            :key="index"
            :title="$t(item.name)"
            :name="item.route"
          >
            <template #title>
              <!-- <van-icon name="more-o" /> -->
              <template
                v-if="
                  $store.state.open_tips &&
                  (item.route == 'TaxadeRebate' || item.route == 'Recompensas')
                "
              >
                <van-tag type="danger">1</van-tag>
              </template>
              {{ $t(item.name) }}
            </template>
          </van-tab>
        </van-tabs>
      </div>
    </div>
  </header>
</template>

<script>
// {
//     name:'popup._Pendente',
//     route:"canReceive"
// },
export default {
  name: 'Icon',
  props: {
    activeName: {
      type: [String],
      required: 'event'
    }
  },
  data() {
    return {
      show: false,
      activeLength: 5,
      tabList: [
        {
          name: 'popup._Eventos',
          route: 'event'
        },
        {
          name: 'popup._VIP',
          route: 'vip'
        },
        {
          name: 'popup._TaxadeRebate',
          route: 'TaxadeRebate'
        },
        {
          name: 'popup._Recompensas',
          route: 'Recompensas'
        },

        {
          name: 'popup._Juros',
          route: 'yuebao'
        },
        {
          name: 'popup._Histórico',
          route: 'records'
        },
        {
          name: 'popup._FundodePrevidência',
          route: 'rechargeFund'
        }
      ]
    };
  },
  methods: {
    routerFun(e, l) {
      this.activeLength = l.length;
      this.$router.push({ name: e });
    },
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>
<style>
.pCKI81C6T6W2e4ZAfsHW .van-tabs__line {
  background-color: var(--theme-primary-color);
  height: auto;
  height: 0.03rem;
}
.pCKI81C6T6W2e4ZAfsHW .van-tabs--line .van-tabs__wrap {
  border-bottom: thin solid var(--theme-color-line);
  height: 0.9rem;
}
</style>
<style scoped>
.danger-cmesn .van-tag--danger {
  display: inline-block;
  box-sizing: border-box;
  min-width: 0.32rem;
  padding: 0 0.08rem;
  color: #fff;
  height: 0.26rem;
  text-align: center;
  position: absolute;
  right: 0.1rem;
  top: 0.05rem;
  /* background: var(--skin__accent_2); */
  border-radius: 0.13rem 0.13rem 0.13rem 0;
  font-size: 0.18rem;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.26rem;
  letter-spacing: normal;
  overflow: visible;
  vertical-align: center;
}
.danger-cmesn .van-tag--danger:before {
  content: '';
  display: inline-block;
  position: absolute;
  bottom: -0.06rem;
  z-index: 20;
  left: 0;
  width: 0;
  height: 0;
  border-left: 0.079rem solid #ee0a24;
  border-top: 0.066rem solid transparent;
  border-bottom: 0.066rem solid transparent;
  font-size: 0;
}
.pCKI81C6T6W2e4ZAfsHW {
  background-color: var(--theme-top-nav-bg);
  /* border-bottom: .01rem solid var(--theme-color-line); */
  height: var(--theme-header-height);
  line-height: normal;
  padding: 0;
  height: 0.9rem;
}
.IZ3RIKA0JMiWHOYb9u5f {
  background-color: var(--theme-main-bg-color);
  border-bottom: 0.01rem solid var(--theme-color-line);
  overflow: hidden;
  width: 100%;
  height: 0.9rem;
  position: fixed;
  z-index: 9999;
}
.IZ3RIKA0JMiWHOYb9u5f .DMmVnO4MrRvIrs3lfxmS {
  cursor: pointer;
  font-size: 0.24rem;
  left: 0;
  padding: 0.33rem 0.4rem 0.27rem 0.2rem;
  position: absolute;
  top: 0;
  z-index: 2;
}
.IZ3RIKA0JMiWHOYb9u5f .DMmVnO4MrRvIrs3lfxmS .imageWrap {
  width: 0.24rem;
  height: 0.24rem;
  color: var(--theme-text-color);
}
.IZ3RIKA0JMiWHOYb9u5f .urdJVIoQ0Du2bRHlCOjg {
  margin-left: 0.84rem;
  width: calc(100% - 0.84rem);
}
.ETlYzQW0ZLPLfrXjv6oO .van-tabs__nav {
  -webkit-overflow-scrolling: touch;
  background-color: var(--theme-main-bg-color);
  display: inline-block;
  overflow-x: auto;
  padding: 0;
  white-space: nowrap;
  width: 100%;
}
</style>
